import { def } from '@gaspardesk/utils';
import moment from 'moment';
import React from 'react';

type IntlDateProps = {
  date: Date | string | number | null;
  granularity?: 'hour' | 'day';
};

export const IntlDateString = ({ date, granularity }: IntlDateProps) => {
  let options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  if (granularity === 'hour') {
    options = { ...options, hour: 'numeric', minute: 'numeric' };
  }
  if (!def(date) || !moment.utc(date).isValid()) {
    return 'N/A';
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const normalizedDate = granularity !== 'hour' ? moment.utc(date).endOf('day').toDate() : moment.utc(date).toDate();
  return new Intl.DateTimeFormat('en-US', options).format(normalizedDate).toString();
};

const IntlDate: React.FunctionComponent<IntlDateProps> = React.memo((props: IntlDateProps) => {
  return <>{IntlDateString(props)}</>;
});
IntlDate.displayName = 'IntlDate';

export default IntlDate;
